
export const expensesData = [{
  "id": 1,
  "name": "Shanon",
  "description": "Corrosion of second degree of single right finger (nail) except thumb",
  "category": "Books",
  "date": "2009-10-10",
  "amount": "947",
  "updated": "4:50 PM",
  "createdBy": "Shanon McIlwrick"
}, {
  "id": 2,
  "name": "Ware",
  "description": "Female infertility associated with anovulation",
  "category": "Health",
  "date": "2009-02-10",
  "amount": "908",
  "updated": "4:45 PM",
  "createdBy": "Ware Kempshall"
}, {
  "id": 3,
  "name": "Desiri",
  "description": "Osteochondritis dissecans, left wrist",
  "category": "Health",
  "date": "2023-05-28",
  "amount": "587",
  "updated": "11:20 PM",
  "createdBy": "Desiri Kempster"
}, {
  "id": 4,
  "name": "Erna",
  "description": "Poisoning by other psychostimulants, assault, initial encounter",
  "category": "Books",
  "date": "1923-10-01",
  "amount": "200",
  "updated": "12:01 PM",
  "createdBy": "Erna Bodiam"
}, {
  "id": 5,
  "name": "Peta",
  "description": "Monoplegia of lower limb following nontraumatic subarachnoid hemorrhage affecting unspecified side",
  "category": "Electronics",
  "date": "2001-04-23",
  "amount": "863",
  "updated": "11:36 AM",
  "createdBy": "Peta McKeady"
}, {
  "id": 6,
  "name": "Moishe",
  "description": "Infection and inflammatory reaction due to internal joint prosthesis",
  "category": "Electronics",
  "date": "2022-09-01",
  "amount": "421",
  "updated": "7:05 AM",
  "createdBy": "Moishe Fritschmann"
}, {
  "id": 7,
  "name": "Devonna",
  "description": "Glider (nonpowered) explosion injuring occupant",
  "category": "Health",
  "date": "1999-07-14",
  "amount": "106",
  "updated": "4:52 PM",
  "createdBy": "Devonna Budibent"
}, {
  "id": 8,
  "name": "Shayne",
  "description": "Presence of artificial hip joint, bilateral",
  "category": "Education",
  "date": "1989-12-30",
  "amount": "329",
  "updated": "12:39 PM",
  "createdBy": "Shayne Dodsworth"
}, {
  "id": 9,
  "name": "Weylin",
  "description": "Driver of bus injured in collision with other nonmotor vehicle in traffic accident, subsequent encounter",
  "category": "Books",
  "date": "2008-03-19",
  "amount": "964",
  "updated": "11:28 PM",
  "createdBy": "Weylin Druhan"
}, {
  "id": 10,
  "name": "Valentina",
  "description": "Corrosion of unspecified degree of unspecified ankle, sequela",
  "category": "Travel",
  "date": "2001-10-01",
  "amount": "600",
  "updated": "12:58 PM",
  "createdBy": "Valentina Mandrey"
}]
